import axios from "axios";
import authHeader from "./auth-header";

import constants from '../../constants/constant.js';


const getStatistic = (data)=>{
     
    if(!data.offset){
        data.offset=0;
    } if (!data.limit){
        data.limit=10
    }
    let filter=''
     
    if(data.filter&& Object.keys(data.filter).length ){
         
    for (const [key, value] of Object.entries(data.filter)) {
         
        value.forEach(el => {
             
            filter+=`&filters[${key}]=${el}`
        });
    }
    } 
    if(data.sort&& Object.keys(data.sort).length ){
        for (const [key, value] of Object.entries(data.sort)) {
                filter+=`&sort[${key}]=${value}`
        }
    }    
    return axios.get(constants.URL + `api/v1/profile-statistics?offset=0&limit=750${filter}`,{headers: authHeader()}).then(response=>{
         
        return response.data
    }).catch((e)=>{
         
        console.log(e);
      });;
}
const getStatisticCompare = (data)=>{
     
    if(!data.offset){
        data.offset=0;
    } if (!data.limit){
        data.limit=10
    }
    let filter=''
     
    if(data.filter&& Object.keys(data.filter).length ){
         
    for (const [key, value] of Object.entries(data.filter)) {
         
        value.forEach(el => {
             
            filter+=`&filters[${key}]=${el}`
        });
    }
    } 
    if(data.sort&& Object.keys(data.sort).length ){
        for (const [key, value] of Object.entries(data.sort)) {
                filter+=`&sort[${key}]=${value}`
        }
    }    
     
    return axios.get(constants.URL + `api/v1/profile-statistics?offset=0&limit=750${filter}`,{headers: authHeader()}).then(response=>{
        return response.data
    }).catch((e)=>{
         
        console.log(e);
      });;
}

const getMotivation =(data)=>{
    return axios.get(constants.URL + `api/v1/weeks-and-day-activity`,{headers: authHeader()}).then(response=>{
        return response.data
    }).catch((e)=>{
        console.log(e);
      });;
}
const getStatisticAll =()=>{
    return axios.get(constants.URL + `api/v1/reports/all`,{headers: authHeader()}).then(response=>{
        return response.data
    }).catch((e)=>{
        console.log(e);
      });;
}
const getChartInfo =()=>{
    return axios.get(constants.URL + `api/v1/reports/month`,{headers: authHeader()}).then(response=>{
        return response.data
    }).catch((e)=>{
        console.log(e);
      });;
}



export default{
    getStatisticCompare,
    getStatistic,
    getMotivation,
    getStatisticAll,
    getChartInfo
}